module.exports = __webpack_public_path__ + "static/img/14000657.0875e5de.png";